<nav class="sidebar card mb-4">
    <div class="top-menu bg-th-gray d-flex justify-content-end w-100 align-items-center">
        <div class="d-flex w-100 col-12 justify-content-between dirI align-items-center">
            <p class="text-start fw-bold mt-2 me-3 text-white f16 vazir">{{fullName}}</p>
            <i class="fa fa-close text-danger fa-2x me-3 pointer" (click)="close()"></i>
        </div>
    </div>

    <p class="text-center bg-th-gray f14 text-white pb-2 mb-1"> </p>
    <span class="text-center bg-th-gray f14 text-white py-1 mb-1"> {{ comapnyName }} </span>
    <ul class="nav flex-column dirI">

        <!-- گزارش و داشبورد -->
        <li class="nav-item" *ngIf="dashboardReportAccessibility">
            <a class="nav-link pointer hoverMenu"> گزارش و داشبورد <b class="float-end">&raquo;</b> </a>
            <ul class="submenu dropdown-menu">
                <!-- عملکرد -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.performance)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">عملکرد<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- گزارش پیمایش دوره‌ای -->
                        <li class="pointer hoverMenu p-1" (click)="sabtReport(1)" *ngIf="acssess.bReportAllNavigation">
                            <i class="fa fa-copy text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold">گزارش پیمایش دوره‌ای</span>
                        </li>
                        <!-- خالص کارکرد روزانه -->
                        <li class="pointer hoverMenu p-1" (click)="sabtReport(3)" *ngIf="acssess.bReportAllFunction">
                            <i class="fa fa-copy text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold"> خالص کارکرد روزانه</span>
                        </li>
                    </ul>
                </li>
                <!-- سوخت -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.fuel)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">سوخت<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- سوخت مصرفی براساس عملکرد -->
                        <li class="pointer hoverMenu p-1" (click)="sabtReport(2)" *ngIf="acssess.bReportFuleBasePerformance_All">
                            <i class="fa fa-copy text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold">سوخت مصرفی براساس عملکرد</span>
                        </li>
                        <!-- سوخت خالص مصرفی خودروها -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bReportNetfuelconsumption_All">
                            <a class="w-100  pointer" target="_blank" routerLink="/reportage/fuel-consumption">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> سوخت خالص مصرفی خودروها </span>
                            </a>
                        </li>
                        <!-- مصرف بر اساس فلومتر -->
                        <li class="pointer hoverMenu p-1" (click)="sabtReport(7)" *ngIf="acssess.bReportfuelBaseFlowmeter_All">
                            <a class="w-100  pointer" target="_blank">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> مصرف بر اساس فلومتر </span>
                            </a>
                        </li>
                        <!-- سوخت براساس گزارش ثبت شده -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bReportfuelBaseReport_All">
                            <a class="w-100  pointer" target="_blank" routerLink="/reportage/fuel-based-report">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> سوخت براساس گزارش ثبت شده </span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- محدوده -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.area)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">محدوده<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- خودروهای واقع در محدوده -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bMobilesArGeoFance">
                            <a class="w-100 pointer" target="_blank" [routerLink]="['/report', 'presenceCheck']">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">خودروهای واقع در محدوده</span>
                            </a>
                        </li>
                        <!-- آخرین حضور در محدوده -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bMobileInGeoFenceHistory">
                            <a class="w-100  pointer" target="_blank" [routerLink]="['/report', 'historyCheck']">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> آخرین حضور در محدوده</span>
                            </a>
                        </li>
                        <!-- بازرسی تاسیسات -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bMobilesInspection">
                            <a class="w-100  pointer" (click)="sabtReport(18)">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> بازرسی تاسیسات</span>
                            </a>
                        </li>
                        <!-- خدمات رسانی خودرو‌ها -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bServiceDelivery">
                            <a class="w-100  pointer" (click)="sabtReport(19)">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> خدمات رسانی خودرو‌ها</span>
                            </a>
                        </li>
                        <!-- حضور در محدوده -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bMobilesFunctionInDomain">
                            <a class="w-100  pointer" target="_blank" href="/reportArea">
                                <i class="fa fa-copy text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> حضور در محدوده</span>
                            </a>
                        </li>
                        <!-- کارکرد مابین مبدا و مقصد -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bMobilesFunctionSD" (click)="sabtReport(6)">
                            <i class="fa fa-history text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold"> کارکرد مابین مبدا و مقصد</span>
                        </li>
                    </ul>
                </li>
                <!-- تعمیرات و نگهداری -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.maintenance)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">تعمیرات و نگهداری<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- تعمیرات -->
                        <li class="pointer hoverMenu p-1" (click)="sabtReport(5)" *ngIf="acssess.bRepairsReport">
                            <i class="fa fa-copy text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold"> تعمیرات</span>
                        </li>
                        <!-- بازدیدهای دوره‌ای -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bPeriodicVisits_Report">
                            <a class="w-100 pointer" target="_blank" routerLink="/periodic-visits">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> بازدیدهای دوره‌ای </span>
                            </a>
                        </li>
                        <!-- گزارش بازرسی‌ها -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bFInspection_Report">
                            <a class="w-100 pointer" target="_blank" [routerLink]="['/inspection-search']">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> گزارش بازرسی‌ها </span>
                            </a>
                        </li>
                        <!-- سررسید سرویس‌ها -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bServiceReport">
                            <a class="w-100 pointer" target="_blank" [routerLink]="['/report', 'repairServices']">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">سررسید سرویس‌ها</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- مالی -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.finance)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">مالی<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- حقوق رانندگان-->
                        <li class="pointer hoverMenu p-1" (click)="sabtReport(4)" *ngIf="acssess.bMobilesSalary">
                            <i class="fa fa-money text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold">حقوق رانندگان</span>
                        </li>
                        <!-- ورود ساعت کارکرد خودروها -->
                        <li class="pointer hoverMenu p-1" (click)="openExelUploder()"
                            *ngIf="acssess.bMobilesImportTimesheet">
                            <i class="fa fa-clock-o text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold">ورود ساعت کارکرد خودروها</span>
                        </li>
                        <!-- پرداخت‌ها -->
                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bFleetYar_PaymentReport')">
                            <a class="w-100  pointer" href="/report-payment" target="_blank">
                                <i class="fa fa-money text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> پرداخت‌ها </span>
                            </a>
                        </li>
                        <!-- خلافی‌ها -->
                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100 pointer">
                                <i class="fa fa-car text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> خلافی‌ها </span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- اعتبار -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.credit)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">اعتبار<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- تمدید اعتبار خودروها -->
                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100 pointer" target="_blank" routerLink="/vehicle-renewal">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> تمدید اعتبار خودروها </span>
                            </a>
                        </li>
                        <!-- ردیاب‌های قطع -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bFleetYar_GPSOFF_List">
                            <a class="w-100 pointer" target="_blank" routerLink="/vehicles-offline">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">ردیاب‌های قطع</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- داشبورد -->
                <li *ngIf="hasAccess(dashboardReportSubMenuAccess.dashboard)" class="nav-item">
                    <a class="nav-link pointer hoverMenu">داشبورد<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- عمومی -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bEnableDashboard">
                            <a class="w-100  pointer" target="_blank" href="/dashbord">
                                <i class="fa fa-line-chart text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">عمومی</span>
                            </a>
                        </li>
                        <!-- تخصصی -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bEnableDashboardProfessional">
                            <a class="w-100  pointer" target="_blank" href="/detailedDashboard">
                                <i class="fa fa-tachometer text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">تخصصی</span>
                            </a>
                        </li>
                        <!-- ترکیبی -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bEnableDashboardHybrid">
                            <a class="w-100  pointer" target="_blank" href="/hybridDashboard">
                                <i class="fa fa-pie-chart text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">ترکیبی</span>
                            </a>
                        </li>
                        <!-- شیلات -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bFisheries_Dashboard">
                            <a class="w-100  pointer" target="_blank" href="/fisheries-dashbord">
                                <i class="fa fa-tachometer text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> شیلات </span>
                            </a>
                        </li>
                        <!-- پیش ثبت‌نام‌ها -->
                        <li class="pointer hoverMenu p-1" *ngIf="acssess.bFleetYar_Advance_PreregistratioDashboard">
                            <a class="w-100  pointer" target="_blank"
                                href="vehicle-management/pre-registration/dashboard">
                                <i class="fa fa-tachometer text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> پیش ثبت‌نام‌ها </span>
                            </a>
                        </li>

                    </ul>
                </li>
            </ul>
        </li>

        <!-- وقایع و ورودی‌ها -->
        <li class="nav-item" *ngIf="eventsAndInputsAccessibility">
            <a class="nav-link pointer hoverMenu">وقایع و ورودی‌ها<b class="float-end">&raquo;</b> </a>
            <ul class="submenu dropdown-menu">
                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bLiveJournal">
                    <a class="w-100  pointer" target="_blank" href="/manageEvent">
                        <i class="fa fa-cubes text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold">مدیریت وقایع</span>
                    </a>
                </li>
                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bLiveJournal">

                    <a class="w-100  pointer" target="_blank" href="/daily-event">

                        <i class="fa fa-cubes text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> وقایع روزانه </span>

                    </a>

                </li>
                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bLiveJournal">
                    <a class="w-100  pointer" target="_blank" href="/manageSos">
                        <i class="fa fa-exclamation-triangle text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold">SOS مدیریت </span>
                    </a>
                </li>
                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bIOManage">
                    <a class="w-100  pointer" target="_blank" href="/manageInput">
                        <i class="fa fa-briefcase text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold">مدیریت ورودی ها </span>
                    </a>
                </li>
                <li class="pointer hoverMenu p-1" *ngIf="acssess.bServiceDelivery">
                    <a class="w-100  pointer" target="_blank" [routerLink]="['/mapInput/report']">
                        <i class="fa fa-copy text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold">نقشه وضعیت خدمات رسانی</span>
                    </a>
                </li>
            </ul>
        </li>

        <!-- مدیریت وسایل نقلیه -->
        <li class="nav-item" *ngIf="fleetManagementAccessibility">

            <a class="nav-link pointer hoverMenu">مدیریت وسایل نقلیه<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bDonotShowMap">

                    <a class="w-100 pointer" target="_blank" href="/vehicle-management/location-timeline">

                        <i class="fa fa-map-marker text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> موقعیت خودروها در زمان </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/carList']">

                    <i class="fa fa-list text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">فهرست خودرو ها</span>

                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/device']" *ngIf="acssess.bEnableAddID">
                    <i class="fa fa-usb text-dark ms-2"></i>
                    <span class="text-dark ms-2 f14 bold">ثبت ردیاب</span>
                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/device/registration']" *ngIf="acssess.bEnableAddID">
                    <i class="fa fa-usb text-dark ms-2"></i>
                    <span class="text-dark ms-2 f14 bold">تکمیل شناسنامه ردیاب </span>
                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bFleetYar_Advance_PreregistrationManagment">

                    <a class="w-100 pointer" href="/vehicle-management/pre-registration/shilat" target="_blank">

                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> پیش ثبت‌نام شیلات </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu"
                    *ngIf="accessibility('bFleetYar_Advance_TankerPreregistrationManagment')">

                    <a class="w-100 pointer" href="/vehicle-management/pre-registration/tanker" target="_blank">

                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> پیش ثبت‌نام تانکر </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess?.bFleetYar_Installer">

                    <a class="w-100 pointer" target="_blank" href="/vehicle-management/installer">

                        <i class="fa fa-user-circle fa-lg text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> کارشناس نصب </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess?.bEquipmentStatistics">
                    <a class="w-100 pointer" target="_blank" href="/vehicle-management/division">
                        <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold"> آمار و تجهیزات </span>
                    </a>
                </li>

                <li class="pointer p-1 hoverMenu" (click)="sabt()" *ngIf="acssess.bEnableAddCar">

                    <i class="fa fa-car text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">ثبت خودرو جدید</span>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bCarAdded">

                    <a class="w-100 pointer" target="_blank" href="/vehicle-management/added-cars">

                        <i class="fa fa-car text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> خودروهای اضافه شده </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bAbortion">

                    <a class="w-100 pointer" target="_blank" href="/vehicle-management/scrap-cars">

                        <i class="fa fa-car text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> خودروهای اسقاطی </span>

                    </a>

                </li>
                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bServiceParts_Manage">
                    <a class="w-100 pointer" target="_blank" routerLink="/service-parts">
                        <i class="fa fa-wrench text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold"> درخواست‌های خدمات و قطعه </span>
                    </a>
                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bAuthentication">
                    <a class="w-100 pointer" target="_blank" routerLink="/validation">
                        <i class="fa fa-id-badge text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold"> احراز هویت </span>
                    </a>
                </li>


            </ul>

        </li>

        <!-- اتوماسیون سفر -->
        <li class="nav-item" *ngIf="tripAutomationAccessibility">

            <a class="nav-link pointer hoverMenu"> اتوماسیون سفر <b class="float-end">&raquo;</b></a>

            <ul class="submenu dropdown-menu">

                <!-- سفر های اداری -->
                <li class="nav-item" *ngIf="accessibility('OffitialTrip_Trip')">

                    <a class="nav-link pointer hoverMenu"> سفر های اداری <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_SaveTrip">

                            <a class="w-100  pointer" (click)="tripModal_Open()">

                                <i class="fa fa-plane text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> ثبت سفر </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_MyPersonelTrip">

                            <a target="_blank" href="/trip/automation/staff-travel">

                                <i class="fa fa-plane text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> سفر های پرسنل من </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_ManageTrips">

                            <a target="_blank" href="/trip/automation/manage-travel">

                                <i class="fa fa-plane text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت سفرها </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_TripsPanning">

                            <a target="_blank" href="/trip/automation/planning-travel">

                                <i class="fa fa-plane text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> برنامه ریزی سفرهای پرسنل </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- جستجو و داشبورد -->
                <li class="nav-item" *ngIf="accessibility('OffitialTrip_Search')">

                    <a class="nav-link pointer hoverMenu">جستجو و داشبورد<b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <!-- جستجوی سفرهای اداری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_TripsSearch">

                            <a class="w-100  pointer" href="trip/dashboard/search-trips" target="_blank">

                                <i class="fa fa-area-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> جستجوی سفرهای اداری </span>

                            </a>

                        </li>

                        <!-- بیوریتم رانندگان  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_DriverBioritm">

                            <a class="w-100 pointer" target="_blank" [routerLink]="['/trip/dashboard/search-driver']">

                                <i class="fa fa-area-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> بیوریتم رانندگان </span>

                            </a>

                        </li>

                        <!-- داشبورد سفرهای اداری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_Dashboard">

                            <a class="w-100  pointer" target="_blank" [routerLink]="['/trip/dashboard/office-travel']">

                                <i class="fa fa-area-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد سفرهای اداری </span>

                            </a>

                        </li>

                        <!-- نمودار کیفی رانندگان -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_DriverQualityReport">

                            <a class="w-100  pointer" target="_blank"
                                [routerLink]="['/trip/dashboard/quality-chart-drivers']">

                                <i class="fa fa-area-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> نمودار کیفی رانندگان </span>

                            </a>

                        </li>

                        <!-- وضعیت سفرها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_TripStatus">

                            <a class="w-100  pointer" target="_blank" [routerLink]="['/trip/dashboard/trip-status']">

                                <i class="fa fa-area-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> وضعیت سفرها </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- گزارش های عملکردی -->
                <li class="nav-item" *ngIf="accessibility('OffitialTrip_FunctionReport')">

                    <a class="nav-link pointer hoverMenu">گزارش های عملکردی<b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_DriverFuncationReport">

                            <a target="_blank" href="trip/report/drivers-function">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> کارکرد رانندگان به تفکیک تاریخ </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_SumDriverFuncationReport">

                            <a target="_blank" href="trip/report/drivers-total-function">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> سرجمع کارکرد رانندگان </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_TripCountBaseChartReport">

                            <a target="_blank" href="/reportage/TripBaseChart">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> تعداد سفر به تفکیک جایگاه </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_TripPlanningReport">

                            <a target="_blank" href="trip/report/planning-trip">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> سفرهای برنامه ریزی شده </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_DriversPresenceReport">

                            <a target="_blank" href="/trip/report/presence-absence-drivers">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> حضور و غیاب رانندگان </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu">

                            <i class="fa fa-list text-dark ms-2"></i>

                            <span class="text-dark ms-2 f14 bold"> گزارش سفر به تفکیک جایگاه </span>

                        </li>

                    </ul>

                </li>

                <!-- گزارش های مالی -->
                <li class="nav-item" *ngIf="accessibility('OffitialTrip_FinanceReport')">

                    <a class="nav-link pointer hoverMenu">گزارش های مالی<b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_FinanceDriversFunctionReport">

                            <a class="w-100  pointer" target="_blank" href="/reportage/financial-reports">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> بررسی و تایید کارکرد رانندگان </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu">

                            <a class="w-100  pointer" target="_blank">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> صدور فیش حقوق رانندگان </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_FinanceDriversPayslipReport">

                            <i class="fa fa-list text-dark ms-2"></i>

                            <span class="text-dark ms-2 f14 bold"> کسورات قانونی و فیش حقوق </span>

                        </li>

                    </ul>

                </li>

                <!-- چارت، پرسنل, کاربران اداری -->
                <li class="nav-item" *ngIf="accessibility('OffitialTrip_UserManagment')">

                    <a class="nav-link pointer hoverMenu">چارت،پرسنل،کاربران اداری<b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <!-- کاربران اتوماسیون اداری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_UserManagment_User_Save">

                            <a target="_blank" href="trip/manage-users/new-user">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> کاربران اتوماسیون اداری </span>

                            </a>

                        </li>

                        <!-- پرسنل اداری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_UserManagment_Passenger_Save">

                            <a target="_blank" href="trip/dashboard/search-personnel">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> پرسنل اداری </span>

                            </a>

                        </li>

                        <!-- چارت سازمانی -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_UserManagment_Chart">

                            <a target="_blank" href="trip/manage-users/chart-definition">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> چارت سازمانی </span>

                            </a>

                        </li>

                        <!-- دسترسی چارت سازمانی -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_UserManagment_Chart_Ability">

                            <a target="_blank" href="trip/manage-users/chart-access-determine">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> دسترسی چارت سازمانی </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- اطلاعات پایه -->
                <li class="nav-item" *ngIf="accessibility('OffitialTrip_BaseInfo')">

                    <a class="nav-link pointer hoverMenu">اطلاعات پایه<b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <!-- اطلاعات پایه اتوماسیون -->

                        <li class="pointer p-1 hoverMenu" [routerLink]="['/tripAutomation']"
                            *ngIf="acssess.OffitialTrip_BaseInfo_Save">

                            <i class="fa fa-list text-dark ms-2"></i>

                            <span class="text-dark ms-2 f14 bold"> اطلاعات پایه اتوماسیون </span>

                        </li>

                        <li class="pointer p-1 hoverMenu" [routerLink]="['/tripAutomation/serviceArea']"
                            *ngIf="acssess.OffitialTrip_BaseInfo_MobileDomain">

                            <i class="fa fa-list text-dark ms-2"></i>

                            <span class="text-dark ms-2 f14 bold">حوزه خدمت</span>

                        </li>

                        <li class="pointer p-1 hoverMenu" (click)="holidayModal()"
                            *ngIf="acssess.OffitialTrip_BaseInfo_Holiday">

                            <i class="fa fa-calendar text-dark ms-2"></i>

                            <span class="text-dark ms-2 f14 bold">ثبت و ویرایش تعطیلات</span>

                        </li>

                        <li class="pointer p-1 hoverMenu" [routerLink]="['basic-information/service-costs']"
                            *ngIf="acssess.OffitialTrip_BaseInfo_Tariff">

                            <i class="fa fa-list text-dark ms-2"></i>

                            <span class="text-dark ms-2 f14 bold"> تعرفه خدمات </span>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_BaseInfo_SAD">

                            <a class="w-100 pointer" target="_blank" href="/basic-information/busy-routes">

                                <i class="fa fa-road text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مسیرهای پرتردد </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.OffitialTrip_BaseInfo_News">

                            <a target="_blank" href="basic-information/news">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> اخبار </span>

                            </a>

                        </li>

                    </ul>

                </li>

            </ul>

        </li>

        <!-- مدیریت کاربران -->
        <li class="nav-item" *ngIf="userManagementAccessibility">

            <a class="nav-link pointer hoverMenu">مدیریت کاربران<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu" [routerLink]="['/changePass']" *ngIf="acssess.bChangePass">

                    <i class="fa fa-key text-dark ms-2"></i>

                    <span class="text-dark ms-2 f14 bold">تغییر کلمه عبور</span>

                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/user']" *ngIf="acssess.bEnableIntroducedMobile">
                    <i class="fa fa-user-circle text-dark ms-2"></i>
                    <span class="text-dark ms-2 f14 bold">کاربران زیر مجموعه شما</span>
                </li>

                <li class="pointer p-1 hoverMenu" [routerLink]="['/saveUser']" *ngIf="acssess.bUserManagment">
                    <i class="fa fa-users text-dark ms-2"></i>
                    <span class="text-dark ms-2 f14 bold">مدیریت کاربران</span>
                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bUserManagment_OnlineUser">

                    <a class="w-100 pointer" routerLink="/online-users">

                        <i class="fa fa-circle  text-success ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> کاربران برخط </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bUserManagment_Group">

                    <a class="w-100 pointer" target="_blank" href="/roles-roleAccesses">

                        <i class="fa fa-universal-access text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> گروه کاربری و دسترسی&zwnj;ها </span>

                    </a>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSupport">
                    <a class="w-100 pointer" target="_blank" href="/supportManager">
                        <i class="fa fa fa-envelope text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold">مدیریت تیکت ها</span>
                    </a>
                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bMobileDomain_Save">
                    <a class="w-100 pointer" target="_blank" href="/ServiceAreas">
                        <i class="fa fa-university text-dark ms-2"></i>
                        <span class="text-dark ms-2 f14 bold"> حوزه های خدمتی </span>
                    </a>
                </li>

            </ul>

        </li>

        <!-- حمل و نقل هوشمند  -->
        <li class="nav-item" *ngIf="transportationAccessibility">

            <a class="nav-link pointer hoverMenu"> حمل و نقل هوشمند <b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <!-- ترانزیت  -->
                <li class="nav-item" *ngIf="accessibility('bTransit','bTransit_Trip','bTransit_Trip_Report')">

                    <a class="nav-link pointer hoverMenu"> ترانزیت <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="d-none pointer p-1 hoverMenu">

                            <a class="w-100 pointer" target="_blank" routerLink="/transit/route-management">

                                <i class="fa fa-road text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت مسیر ها </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTransit_Trip')">

                            <a class="w-100 pointer" target="_blank" routerLink="/transit/barnameh">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> ثبت بارنامه </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTransit_Trip_Report')">

                            <a class="w-100 pointer" target="_blank" routerLink="/transit/performance-report">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش عملکرد </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTransit_Trip_Report')">

                            <a class="w-100 pointer" target="_blank" routerLink="/transit/without-planning-report">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش آزاد عملکرد </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTransit_Trip_Report')">

                            <a class="w-100 pointer" target="_blank" routerLink="/transit/time-report">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش ترانزیت تایم </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu">

                            <a class="w-100 pointer" target="_blank">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد ترانزیت </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- ایاب و ذهاب گروهی  -->
                <li class="nav-item"
                    *ngIf="accessibility('bRoute','bRoute_Route_Schdeule','bRoute_Management','bTransportation_Performance','bRoute_Reports')">

                    <a class="nav-link pointer hoverMenu"> ایاب و ذهاب گروهی <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bRoute_Management">

                            <a class="w-100 pointer" target="_blank" href="/route-management">

                                <i class="fa fa-road text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت مسیر </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bRoute_Route_Schdeule">

                            <a class="w-100 pointer" target="_blank" href="/route-schedule">

                                <i class="fa fa-calendar text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> برنامه سرویس </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bRoute_Reports')">

                            <a class="w-100 pointer" target="_blank" href="/report/0000000/21">

                                <i class="fa fa-car text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> تحلیل عملکرد ایاب و ذهاب </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTransportation_Performance')">

                            <a class="w-100 pointer" target="_blank" href="/report/0000000/21-1">

                                <i class="fa fa-road text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> تحلیل گزارش عملکرد مسیر ها </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bRoute_Reports')">

                            <a class="w-100 pointer" target="_blank" href="/report/0000000/22">

                                <i class="fa fa-car text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> سرجمع عملکرد خودرو براساس مسیر </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bRoute_Reports')">

                            <a class="w-100 pointer" target="_blank" href="/report/0000000/23">

                                <i class="fa fa-road text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> سرجمع عملکرد راننده براساس مسیر </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu">

                            <a class="w-100 pointer" target="_blank" href="personnel/detail-service">

                                <i class="fa fa-bar-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش جزئیات پرسنل در سرویس </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bRoute_Reports')">

                            <a class="w-100 pointer" target="_blank" href="/route-dashboard">

                                <i class="fa fa-bar-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد ایاب ذهاب </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bRoute_Service_Dashboard')">

                            <a class="w-100 pointer" target="_blank" href="/ayab-zahab/dashboard">

                                <i class="fa fa-bar-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد وضعیت سرویس ها </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- تاکسی لون -->
                <li class="nav-item"
                    *ngIf="accessibility('bTaxiLon','bTaxiLon_ManageTrip','bTaxiLon_Drivers','bTaxiLon_Reports','bTaxiLon_PaymentReport')">

                    <a class="nav-link pointer hoverMenu"> تاکسی لون <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <!-- مدیریت تاکسی بین شهری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_ManageTrip')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/manage-requests">

                                <i class="fa fa-list-ul text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت تاکسی بین شهری </span>

                            </a>

                        </li>

                        <!-- مدیریت تاکسی شهری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_City_ManageTrip')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/manage-requests-city">

                                <i class="fa fa-list-ul text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت تاکسی شهری </span>

                            </a>

                        </li>

                        <!-- مدیریت رانندگان -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Drivers')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/manage-drivers">

                                <i class="fa fa-id-card text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت رانندگان </span>

                            </a>

                        </li>

                        <!-- مدیریت آگهی ها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Advertisement')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/manage-ads">

                                <i class="fa fa-newspaper-o text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت آگهی&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- رزرو تاکسی بین شهری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Trip_Save')">

                            <a class="w-100 pointer" (click)="isTrip_Save = true">

                                <i class="fa fa-car text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> رزرو تاکسی بین شهری </span>

                            </a>

                        </li>

                        <!-- رزرو تاکسی شهری -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Trip_Save')">

                            <a class="w-100 pointer" (click)="isInCity = true;isTrip_Save = true">

                                <i class="fa fa-car text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> رزرو تاکسی شهری </span>

                            </a>

                        </li>

                        <!-- جستجوی سفر ها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Trip_Search')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/search-trip">

                                <i class="fa fa-search text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> جستجوی سفر&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- جستجوی مسافران -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_User_Search')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/search-passenger">

                                <i class="fa fa-search text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> جستجوی مسافران </span>

                            </a>

                        </li>

                        <!-- گزارش پرداخت ها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_PaymentReport')">

                            <a class="w-100  pointer" href="/taxiLon/report-payment" target="_blank">

                                <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش پرداخت ها </span>

                            </a>

                        </li>

                        <!-- گزارش ها و داشبورد -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Reports')">

                            <a class="w-100  pointer" href="/taxiLon/dashbord-reports" target="_blank">

                                <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش&zwnj;ها و داشبورد </span>

                            </a>

                        </li>

                        <!-- بدهکاری/بستانکاری رانندگان  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_DriverDebitCredit')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/debit-credit">

                                <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> بدهکاری/بستانکاری رانندگان </span>

                            </a>

                        </li>

                        <!-- برنامه سفرهای رانندگان  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_DriverCalendar')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/driver-calendar">

                                <i class="fa fa-calendar fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> برنامه سفرهای رانندگان </span>

                            </a>

                        </li>

                        <!-- تعرفه -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Tariff')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/tariff">

                                <i class="fa fa-money fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> تعرفه&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- پشتیبانی و شکایات  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_TiketManagment')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/support">

                                <i class="fa fa-headphones fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> پشتیبانی و شکایات </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- امدادران -->
                <li class="nav-item"
                    *ngIf="accessibility('bEmdadRan','bEmdadRan_TiketManagment','bEmdadRan_Drivers','bEmdadRan_User_Search','bEmdadRan_ManageTrip','bEmdadRan_Resume')">

                    <a class="nav-link pointer hoverMenu"> امدادران <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <!-- مدیریت درخواست ها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_ManageTrip')">

                            <a class="w-100 pointer" target="_blank" href="/emdadran/manage-requests">

                                <i class="fa fa-list-ul text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت درخواست ها </span>

                            </a>

                        </li>

                        <!-- مدیریت آگهی ها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTaxiLon_Advertisement')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/manage-ads">

                                <i class="fa fa-newspaper-o text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت آگهی&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- مدیریت کسب و کار -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_Resume')">

                            <a class="w-100 pointer" target="_blank" href="/emdadran/manage-business">

                                <i class="fa fa-briefcase text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت کسب و کار&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- مدیریت رانندگان -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_Drivers')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/manage-drivers">

                                <i class="fa fa-id-card text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت رانندگان </span>

                            </a>

                        </li>

                        <!-- متقاضیان -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_User_Search')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/search-passenger">

                                <i class="fa fa-search text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> متقاضیان </span>

                            </a>

                        </li>

                        <!-- جستجوی درخواست ها -->

                        <li class="pointer p-1 hoverMenu">

                            <a class="w-100 pointer" target="_blank" href="/emdadran/search-requests">

                                <i class="fa fa-search text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> جستجوی درخواست&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- تعرفه -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_Tariff')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/tariff-2">

                                <i class="fa fa-money fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> تعرفه&zwnj;ها </span>

                            </a>

                        </li>

                        <!-- گزارش پرداخت ها -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bFleetYar_PaymentReport')">

                            <a class="w-100  pointer" href="/emdadran/report-payment" target="_blank">

                                <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش پرداخت ها </span>

                            </a>

                        </li>

                        <!-- گزارش ها و داشبورد -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_Dashboard')">

                            <a class="w-100  pointer" href="/emdadran/dashbord-reports" target="_blank">

                                <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش&zwnj;ها و داشبورد </span>

                            </a>

                        </li>

                        <!-- بدهکاری/بستانکاری رانندگان  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_DriverDebitCredit')">

                            <a class="w-100 pointer" target="_blank" href="/emdadran/debit-credit">

                                <i class="fa fa-info-circle fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> بدهکاری/بستانکاری رانندگان </span>

                            </a>

                        </li>

                        <!-- پشتیبانی و شکایات  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bEmdadRan_TiketManagment')">

                            <a class="w-100 pointer" target="_blank" href="/taxiLon/support">

                                <i class="fa fa-headphones fa-lg text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> پشتیبانی و شکایات </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- اتوبوس شهری -->
                <li class="nav-item"
                    *ngIf="accessibility('bBusesPresenceAtStation','bBusPresenceAtStations','bBusEdit')">
                    <a class="nav-link pointer hoverMenu">اتوبوس شهری<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bBusEdit">
                            <a class="w-100  pointer" target="_blank" href="/busLine">
                                <i class="fa fa-bus text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> مدیریت خطوط اتوبوسرانی</span>
                            </a>
                        </li>
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bBusPresenceAtStations">
                            <a class="w-100  pointer" target="_blank" [routerLink]="['/report', 'busPresence']">
                                <i class="fa fa-slideshare text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">گزارش حضور اتوبوس در ایستگاه ها</span>
                            </a>
                        </li>
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bBusesPresenceAtStation">
                            <a class="w-100  pointer" target="_blank" [routerLink]="['/report', 'station']">
                                <i class="fa fa-bus text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold">گزارش حضور اتوبوس ها در ایستگاه</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- تاکسی شهری -->
                <li class="nav-item"
                    *ngIf="accessibility('bTaxi_LineManagment','bTaxiADSReport','bTaxiSaveADS','bTaxiDashboard','bSaveTaxiMeter')">

                    <a class="nav-link pointer hoverMenu">تاکسی شهری <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxi_LineManagment">

                            <a class="w-100 pointer" target="_blank" href="/taxi-line">

                                <i class="fa fa-road text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> مدیریت خطوط تاکسی </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu " [routerLink]="['/taxiMeter']" *ngIf="acssess.bSaveTaxiMeter">
                            <i class="fa fa-taxi text-dark ms-2"></i>
                            <span class="text-dark f14 bold"> ثبت تعرفه تاکسی </span>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxiDashboard">
                            <a class="w-100  pointer" target="_blank" href="/dashbordTaxi">
                                <i class="fa fa-taxi text-dark ms-2"></i>
                                <span class="text-dark  f14 bold"> داشبورد تاکسی </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxiSaveADS"
                            [routerLink]="['/advertiseTaxi']">
                            <i class="fa fa-taxi text-dark ms-2"></i>
                            <span class="text-dark f14 bold">ثبت تبلیغات </span>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxiADSReport">
                            <a class="w-100  pointer" target="_blank" href="/dashbordAdds">
                                <i class="fa fa-taxi text-dark ms-2"></i>
                                <span class="text-dark f14 bold"> داشبورد تبلیغات </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxi_Vacation_Managment">
                            <a class="w-100  pointer" target="_blank" href="/vehicle-management/taxi/manage-vacation">
                                <i class="fa fa-tasks text-dark ms-2"></i>
                                <span class="text-dark f14 bold"> مدیریت مرخصی </span>
                            </a>
                        </li>

                        <!-- گزارش عملکرد ماهیانه -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxi_OnlineDashboard">

                            <a class="w-100  pointer" target="_blank" href="/vehicle-management/taxi/monthly-report">

                                <i class="fa fa-tasks text-dark ms-2"></i>

                                <span class="text-dark f14 bold"> گزارش عملکرد ماهیانه </span>

                            </a>

                        </li>

                        <!-- داشبورد وضعیت فعلی ناوگان -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxi_OnlineDashboard">

                            <a class="w-100  pointer" target="_blank" href="/vehicle-management/taxi/status-dashboard">

                                <i class="fa fa-tasks text-dark ms-2"></i>

                                <span class="text-dark f14 bold"> داشبورد وضعیت فعلی ناوگان </span>

                            </a>

                        </li>

                        <!-- داشبورد جامع -->

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTaxi_OnlineDashboard">

                            <a class="w-100  pointer" target="_blank" href="/vehicle-management/taxi/dashboard">

                                <i class="fa fa-tasks text-dark ms-2"></i>

                                <span class="text-dark f14 bold"> داشبورد جامع </span>

                            </a>

                        </li>

                    </ul>

                </li>

            </ul>

        </li>

        <!-- IOT  -->
        <li class="nav-item" *ngIf="accessibility('bIOT')">

            <a class="nav-link pointer hoverMenu"> IOT <b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <!-- LoadWatch  -->
                <li class="nav-item" *ngIf="accessibility('bLoadWatch')">

                    <a class="nav-link pointer hoverMenu"> LoadWatch <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <!-- لیست دیزل‌ها -->
                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bLoadWatch_List')">
                            <a class="w-100 pointer" target="_blank" routerLink="/iot/load-watch/list">
                                <i class="fa fa-list text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> لیست دیزل‌ها </span>
                            </a>
                        </li>

                        <!-- داشبورد برخط -->
                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bLoadWatch_Dashboard')">
                            <a class="w-100 pointer" target="_blank" routerLink="/iot/load-watch/dashboard">
                                <i class="fa fa-list text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> داشبورد برخط </span>
                            </a>
                        </li>

                        <!-- گزارش عملکرد -->
                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100 pointer" target="_blank" routerLink="/iot/load-watch/performance">
                                <i class="fa fa-list text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> گزارش عملکرد </span>
                            </a>
                        </li>

                        <!-- وقایع دیزل -->
                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100 pointer" target="_blank" >
                                <i class="fa fa-list text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> وقایع دیزل </span>
                            </a>
                        </li>

                    </ul>

                </li>

            </ul>

        </li>

        <!-- لوجستیک  -->
        <li class="nav-item" *ngIf="logisticsAccessibility">
            <a class="nav-link pointer hoverMenu"> لوجستیک <b class="float-end">&raquo;</b> </a>
            <ul class="submenu dropdown-menu">
                <!-- مدیریت تانکرها -->
                <li class="nav-item"
                    *ngIf="accessibility('bTanker_Dashboard','bTanker_Shower_Edit','bTanker_List','bTanker_Reports')">

                    <a class="nav-link pointer hoverMenu"> مدیریت تانکرها <b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTanker_Reports">

                            <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> گزارش ها <b class="float-end">&raquo;</b></a>

                            <ul class="submenu dropdown-menu">

                                <li class="pointer p-1 hoverMenu">
                                    <a class="w-100 pointer" target="_blank" href="/tanker/analysis-discharges">
                                        <i class="fa fa-file-text-o text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> تحلیل تخلیه ها </span>
                                    </a>
                                </li>

                                <li class="pointer p-1 hoverMenu">

                                    <a class="w-100 pointer" target="_blank" href="/tanker/Report">

                                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> گزارش وضعیت تانکر ها </span>

                                    </a>

                                </li>

                                <li class="pointer p-1 hoverMenu">

                                    <a class="w-100 pointer" target="_blank" href="/tanker/base-Source">

                                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> شرح تامین به تفکیک منبع </span>

                                    </a>

                                </li>

                                <li class="pointer p-1 hoverMenu">
                                    <a class="w-100 pointer" target="_blank" href="/tanker/base-Tanker">
                                        <i class="fa fa-file-text-o text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> شرح تامین به تفکیک تانکر </span>
                                    </a>
                                </li>

                                <li class="pointer p-1 hoverMenu">
                                    <a class="w-100 pointer" target="_blank" href="/tanker/illegal-water-percentage">
                                        <i class="fa fa-file-text-o text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> درصد آبگیری‌های غیر‌مجاز </span>
                                    </a>
                                </li>

                                <li class="pointer p-1 hoverMenu">
                                    <a class="w-100 pointer" target="_blank" href="/tanker/drivers-risk-ranking">
                                        <i class="fa fa-file-text-o text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> رتبه‌بندی رانندگان پرخطر </span>
                                    </a>
                                </li>

                                <li class="pointer p-1 hoverMenu">
                                    <a class="w-100 pointer" target="_blank" href="/tanker/illegal-water-sources">
                                        <i class="fa fa-file-text-o text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> نقشه نقاط آبگیری غیر‌مجاز </span>
                                    </a>
                                </li>

                            </ul>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTanker_Tanker_WaterClient">
                            <a class="w-100  pointer" target="_blank" href="/tanker/customer-management">
                                <i class="fa fa-address-book text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> مدیریت مشتریان </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100  pointer" target="_blank" href="/tanker/areas">
                                <i class="fa fa-map-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> امور </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100  pointer" target="_blank" href="/tanker/execution-report">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> گزارش اجرا </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100 pointer" target="_blank" href="/tanker/water-requests">
                                <i class="fa fa-file-text-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> درخواست‌های آب  </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTanker_List">
                            <a class="w-100  pointer" target="_blank" href="/tanker/list">
                                <i class="fa fa-truck text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> شناسنامه تانکر </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTanker_Shower_Edit">

                            <a class="w-100  pointer" target="_blank" href="/tanker/Supply-locations">

                                <i class="fa fa-database text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> محل های تامین </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bTanker_Dashboard">

                            <a class="w-100  pointer" target="_blank" href="/tanker/dashbord">

                                <i class="fa fa-bar-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد </span>

                            </a>

                        </li>

                    </ul>

                </li>
                <!-- اجاره وسیله نقلیه -->
                <li class="nav-item" *ngIf="accessibility('bRent')">

                    <a class="nav-link pointer hoverMenu">اجاره وسیله نقلیه<b class="float-end">&raquo;</b> </a>

                    <ul class="submenu dropdown-menu">
                        <!-- گزارش و داشبورد  -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bRent_Report">

                            <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> گزارش و داشبورد <b
                                    class="float-end">&raquo;</b></a>

                            <ul class="submenu dropdown-menu">

                                <!-- عملکرد به تفکیک تاریخ -->

                                <li class="pointer p-1 hoverMenu">

                                    <a class="w-100 pointer" target="_blank" href="/vehicle-rental/performance-byDate">

                                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> عملکرد به تفکیک تاریخ </span>

                                    </a>

                                </li>

                                <!-- جزئیات اجاره -->

                                <li class="pointer p-1 hoverMenu">

                                    <a class="w-100 pointer" target="_blank" href="/vehicle-rental/rental-details">

                                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> جزئیات اجاره </span>

                                    </a>

                                </li>

                                <!-- داشبورد -->

                                <li class="pointer p-1 hoverMenu">

                                    <a class="w-100 pointer" target="_blank" href="/vehicle-rental/rent-dashboard">

                                        <i class="fa fa-dashboard text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> داشبورد </span>

                                    </a>

                                </li>

                            </ul>

                        </li>
                        <!-- اجاره های فعال -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bRent_Active">

                            <a class="w-100 pointer" target="_blank" href="/vehicle-rental/active">

                                <i class="fa fa-car text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> اجاره&zwnj;های فعال </span>

                            </a>

                        </li>
                        <!-- اطلاعات پایه  -->
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bRent_BaseInfo">

                            <a class="w-100 pointer" target="_blank" href="/vehicle-rental/base-information">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> اطلاعات پایه </span>

                            </a>

                        </li>
                    </ul>

                </li>
                <!-- تلمتری CAN  -->
                <li class="nav-item" *ngIf="accessibility('bTelemetry')">
                    <a class="nav-link pointer hoverMenu">تلمتری CAN<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- داشبورد وضعیت شارژ -->
                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTelemetry_ChargeStatus')">
                            <a class="w-100 pointer" target="_blank" routerLink="/telemetry/charge-status">
                                <i class="fa fa-battery text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> داشبورد وضعیت شارژ </span>
                            </a>
                        </li>
                        <!-- تحلیل اطلاعات CAN -->
                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bTelemetry_ChargeStatus')">
                            <a class="w-100 pointer" target="_blank" routerLink="/telemetry/can-analyzer">
                                <i class="fa fa-bar-chart text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> تحلیل اطلاعات CAN </span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- فیلیت دیاگ  -->
                <li class="nav-item" *ngIf="accessibility('bFleetDiag')">
                    <a class="nav-link pointer hoverMenu">فیلیت دیاگ<b class="float-end">&raquo;</b> </a>
                    <ul class="submenu dropdown-menu">
                        <!-- کاربران -->
                        <li class="pointer p-1 hoverMenu">
                            <a class="w-100 pointer" target="_blank" routerLink="/fleetdiag/users">
                                <i class="fa fa-users text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> کاربران </span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>

        <!-- نظارت تصویری  -->
        <li class="nav-item" *ngIf="cctvAccessibility">

            <a class="nav-link pointer hoverMenu"> نظارت تصویری <b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <!-- دوربین‌ها -->
                <li class="pointer p-1 hoverMenu">

                    <a class="w-100 pointer" target="_blank" href="/cctv-monitoring/cameras">

                        <i class="fa fa-camera text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> دوربین‌ها </span>

                    </a>

                </li>

                <!-- پارکینگ‌‌ها -->
                <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bVideoSurveillance_Parking')">

                    <a class="w-100 pointer" target="_blank" href="/cctv-monitoring/video-locations">

                        <i class="fa fa-camera text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> پارکینگ‌‌ها </span>

                    </a>

                </li>

                <!-- مدیریت فیلم‌ها -->
                <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bVideoSurveillance_LastUpload')">

                    <a class="w-100 pointer" target="_blank" href="/cctv-monitoring/film-report">

                        <i class="fa fa-camera text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> مدیریت فیلم‌ها </span>

                    </a>

                </li>

                <!-- وضعیت تخلیه فیلم‌ها  -->
                <li class="pointer p-1 hoverMenu">

                    <a class="w-100 pointer" target="_blank" href="/cctv-monitoring/status">

                        <i class="fa fa-camera text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> وضعیت تخلیه فیلم‌ها </span>

                    </a>

                </li>
                <!-- وقایع رخ داده -->
                <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bVideoSurveillance_Events')">

                    <a class="w-100 pointer" target="_blank">

                        <i class="fa fa-hashtag text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> وقایع رخ داده </span>

                    </a>

                </li>

                <!-- نقشه وقایع -->
                <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bVideoSurveillance_Events')">

                    <a class="w-100 pointer" target="_blank">

                        <i class="fa fa-map text-dark ms-2"></i>

                        <span class="text-dark ms-2 f14 bold"> نقشه وقایع </span>

                    </a>

                </li>

            </ul>

        </li>

        <!-- مدونیک -->
        <li class="nav-item" *ngIf="madonikAccessibility">

            <a class="nav-link pointer hoverMenu"> مدونیک <b class="float-end">&raquo;</b></a>

            <ul class="submenu dropdown-menu">

                <li class="pointer p-1 hoverMenu">

                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;">اطلاعات پایه<b
                            class="float-end">&raquo;</b></a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" [routerLink]="['/school/newSchool']"
                            *ngIf="acssess.bSchoolService_MobileDomain">
                            <i class="fa fa-graduation-cap text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold"> ثبت مدرسه </span>
                        </li>

                        <li class="pointer p-1 hoverMenu" [routerLink]="['/school/userSchool']"
                            *ngIf="acssess.bSchoolService_UserMobileDomain">
                            <i class="fa fa-university text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold"> تعیین مدارس کاربر </span>
                        </li>

                        <li class="pointer p-1 hoverMenu" [routerLink]="['/school/newStudent']"
                            *ngIf="acssess.bSchoolService_Student_Save">
                            <i class="fa fa-user-plus text-dark ms-2"></i>
                            <span class="text-dark ms-2 f14 bold"> ثبت دانش آموز </span>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchool_Manager_SuperClass')">

                            <a target="_blank" href="school/extra-classes">

                                <i class="fa fa-university text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> کلاس های فوق برنامه </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchool_News')">

                            <a target="_blank" href="basic-information/news">

                                <i class="fa fa-list text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> اخبار </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- جستجو و مرور -->

                <li class="pointer p-1 hoverMenu"
                    *ngIf="accessibility('bSchool_School_Financial_Report','bSchool_PM_ManageSchool_VoiceMessage','bSchool_PM_ManageSchool_Events','bSchoolService_ChangeAddress','bSchool_AttendingExams','bSchoolService_SchoolAbsence','bSchoolService_Absence','bSchoolService_Absences','bSchoolService_Student_Search')">

                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;">جستجو و مرور<b
                            class="float-end">&raquo;</b></a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Student_Search">

                            <a class="w-100 pointer" target="_blank" href="/school/searchStudent">
                                <i class="fa fa-search text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> جستجوی دانش آموز </span>
                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_SchoolAbsence">

                            <a class="w-100 pointer" target="_blank" href="/school/absenceTo-School">
                                <i class="fa fa-user-times text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> غیبت به مدرسه </span>
                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.Madonik_EntryExit">

                            <a class="w-100 pointer" target="_blank" href="/school/entry-exit">

                                <i class="fa fa-user-times text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش ورود و خروج </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_PM_ManageSchool_Events">

                            <a class="w-100 pointer" target="_blank" href="/school/conferences">
                                <i class="fa fa-calendar-check-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> همایش ها و رخداد ها </span>
                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_PM_ManageSchool_VoiceMessage">

                            <a class="w-100 pointer" target="_blank" href="/school/manager-Message">
                                <i class="fa fa-comments-o text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> پیام مدیر </span>
                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolService_DailyReports')">

                            <a class="w-100 pointer" target="_blank" href="/school/daily-report">

                                <i class="fa fa-info-circle text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش های روزانه </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <!-- گزارش و داشبورد -->

                <li class="pointer p-1 hoverMenu"
                    *ngIf="accessibility('bSchool_School_Dashboard','bSchoolService_Dashboard','bSchoolService_DashboardLive','bSchoolService_DriverFunction','bSchoolService_MonitoringDashboard')">

                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;">گزارش و داشبورد<b
                            class="float-end">&raquo;</b></a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu">

                            <a class="w-100 pointer" target="_blank" href="/school/present-Students">

                                <i class="fa fa-hand-paper-o text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> دانش آموزان حاضر </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_AttendingExams">

                            <a class="w-100 pointer" target="_blank" href="/school/AttendingExams">

                                <i class="fa fa-hand-paper-o text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> دانش آموزان حاضر در امتحان </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Absences">

                            <a class="w-100 pointer" target="_blank" href="/school/absence-Students">

                                <i class="fa fa-user-times text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> دانش آموزان غایب </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Dashboard">
                            <a class="w-100 pointer" target="_blank" href="/school/accumulative-Dashboard">
                                <i class="fa fa-bar-chart text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> داشبورد تجمیعی </span>
                            </a>
                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_School_Dashboard">

                            <a class="w-100 pointer" target="_blank" href="/school/school-Dashboard">

                                <i class="fa fa-bar-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد مدرسه </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolService_MonitoringDashboard')">

                            <a class="w-100 pointer" target="_blank" href="/school/monitoring-dashboard">

                                <i class="fa fa-bar-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد نظارتی </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <li class="pointer p-1 hoverMenu"
                    *ngIf="accessibility('bSchoolService_Tiket4Rayan','bSchoolService_Tiket4School','bSchoolService_Tiket')">
                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;">شکایات و تشکر ها<b
                            class="float-end">&raquo;</b></a>
                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Tiket4School">
                            <a class="w-100 pointer" target="_blank" href="/school/solutions">
                                <i class="fa fa-commenting text-dark ms-2"></i>
                                <span class="text-dark ms-2 f14 bold"> پیشنهادات و راه کارها </span>
                            </a>
                        </li>
                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Tiket4Rayan">

                            <a class="w-100 pointer" target="_blank" href="/school/school-Support">

                                <i class="fa fa-commenting text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> پشتیبانی نرم افزار </span>

                            </a>
                        </li>
                    </ul>
                </li>

                <li class="pointer p-1 hoverMenu"
                    *ngIf="accessibility('bSchool_BuffetReport','bSchool_BuffetSave','bSchool_PrebuyReport')">

                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> بوفه <b
                            class="float-end">&raquo;</b></a>

                    <ul class="submenu dropdown-menu">

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_BuffetSave">

                            <a class="w-100 pointer" target="_blank" href="/school/buffet">

                                <i class="fa fa-coffee text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> ثبت کالای بوفه </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_PrebuyReport">

                            <a class="w-100 pointer" target="_blank" href="/school/presell-Buffet">

                                <i class="fa fa-coffee text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> پیش فروش های بوفه </span>

                            </a>

                        </li>

                        <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_BuffetReport">

                            <!-- <li class="pointer p-1 hoverMenu" > -->

                            <a class="w-100 pointer" target="_blank" href="/school/buffetSales-Report">

                                <i class="fa fa-coffee text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> گزارش فروش بوفه </span>

                            </a>

                        </li>


                    </ul>

                </li>

                <li class="pointer p-1 hoverMenu"
                    *ngIf="accessibility('bSchoolVoice','bSchoolVoice_Request_Save','bSchoolVoice_CartableDefine')">

                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> صدای دانش آموز <b
                            class="float-end">&raquo;</b></a>

                    <ul class="submenu dropdown-menu">

                        <!-- تعریف کارتابل پرسنل  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolVoice_CartableDefine')">

                            <a class="w-100 pointer" target="_blank" href="school/request-allocation">

                                <i class="fa fa-user text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> تعریف کارتابل پرسنل </span>

                            </a>

                        </li>

                        <!-- درخواست والدین  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolVoice_Request_Save')">

                            <a class="w-100 pointer" target="_blank" href="school/parent-requests">

                                <i class="fa fa-user text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> درخواست والدین </span>

                            </a>

                        </li>

                        <!-- رسیدگی به درخواست  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchool_Request_Cartable')">

                            <a class="w-100 pointer" target="_blank" href="javascript:void(0)">

                                <i class="fa fa-search text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> رسیدگی به درخواست </span>

                            </a>

                        </li>

                        <!-- جستجو  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolVoice_Request_Search')">

                            <a class="w-100 pointer" target="_blank" href="school/search-requests">

                                <i class="fa fa-search text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> جستجو </span>

                            </a>

                        </li>

                        <!-- داشبورد  -->

                        <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolVoice_Request_Dashboard')">

                            <a class="w-100 pointer" target="_blank" href="javascript:void(0)">

                                <i class="fa fa-pie-chart text-dark ms-2"></i>

                                <span class="text-dark ms-2 f14 bold"> داشبورد </span>

                            </a>

                        </li>

                    </ul>

                </li>

                <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bSchoolService')">

                    <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> سرویس مدرسه <b
                            class="float-end">&raquo;</b></a>

                    <ul class="submenu dropdown-menu">

                        <!-- تعاریف پایه -->

                        <li class="pointer p-1 hoverMenu">

                            <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> تعاریف پایه <b
                                    class="float-end">&raquo;</b></a>

                            <ul class="submenu dropdown-menu">

                                <!-- مدیریت پیمانکاران -->

                                <li class="pointer p-1 hoverMenu"
                                    *ngIf="accessibility('bSchool_Contractors','bSchool_ContractorInfo')">

                                    <a class="w-100 pointer" target="_blank" href="/school/contractor">

                                        <i class="fa fa-graduation-cap text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> مدیریت پیمانکاران </span>

                                    </a>

                                </li>

                                <!-- تعریف سرویس مدرسه -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bMadonik_Tariff">

                                    <a class="w-100 pointer" target="_blank" href="/school/service-fee">

                                        <i class="fa fa-usd text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> تعرفه سرویس مدرسه </span>

                                    </a>

                                </li>

                                <!-- تعیین سرویس دانش آموزان -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_DetermineDriver">
                                    <a class="w-100 pointer" target="_blank" href="/school/service-Determination">
                                        <i class="fa fa-map-o text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> تعیین سرویس دانش آموزان </span>
                                    </a>
                                </li>

                                <!-- سرویس های راننده -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_DriverPlan">
                                    <a class="w-100 pointer" target="_blank" href="/school/driverService">
                                        <i class="fa fa-male text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> سرویس های راننده </span>
                                    </a>
                                </li>

                            </ul>

                        </li>

                        <!-- گزارش و داشبورد -->

                        <li class="pointer p-1 hoverMenu">

                            <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> گزارش و داشبورد <b
                                    class="float-end">&raquo;</b></a>

                            <ul class="submenu dropdown-menu">

                                <!-- جستجو و مرور راننده -->

                                <li class="pointer p-1 hoverMenu">

                                    <a class="w-100 pointer" target="_blank" href="/school/searchDrivers">

                                        <i class="fa fa-file-text-o text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> جستجو و مرور راننده </span>

                                    </a>

                                </li>

                                <!-- متقاضی سرویس مدرسه -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_ServiceRequest">
                                    <a class="w-100 pointer" target="_blank" href="/school/serviceApplicant-4school">
                                        <i class="fa fa-bus text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> متقاضی سرویس مدرسه </span>
                                    </a>
                                </li>

                                <!-- تغییر آدرس -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_ChangeAddress">

                                    <a class="w-100 pointer" target="_blank" href="/school/change-Address">
                                        <i class="fa fa-map-marker text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> تغییر آدرس </span>
                                    </a>

                                </li>

                                <!-- غیبت از سرویس -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Absence">

                                    <a class="w-100 pointer" target="_blank" href="/school/service-Absence">

                                        <i class="fa fa-user-times text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> غیبت از سرویس </span>

                                    </a>

                                </li>

                                <!-- عملکرد رانندگان -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_DriverFunction">
                                    <a class="w-100 pointer" target="_blank" href="/school/driverPerformance">
                                        <i class="fa fa-id-card text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> عملکرد رانندگان </span>
                                    </a>
                                </li>

                                <!-- داشبورد برخط -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_DashboardLive">
                                    <a class="w-100 pointer" target="_blank" href="/school/realTime-Dashboard">
                                        <i class="fa fa-bar-chart text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> داشبورد برخط </span>
                                    </a>
                                </li>

                                <!-- شکایات از سرویس -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchoolService_Tiket">
                                    <a class="w-100 pointer" target="_blank" href="/school/complaints">
                                        <i class="fa fa-commenting text-dark ms-2"></i>
                                        <span class="text-dark ms-2 f14 bold"> شکایات از سرویس </span>
                                    </a>
                                </li>

                            </ul>

                        </li>

                        <!-- قرارداد و مالی -->

                        <li class="pointer p-1 hoverMenu">

                            <a class="nav-link pointer hoverMenu" style="padding: 0 10px 0 10px;"> قرارداد و مالی <b
                                    class="float-end">&raquo;</b></a>

                            <ul class="submenu dropdown-menu">

                                <!-- قراردادها -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bMadonik_ServiceContract">

                                    <a class="w-100 pointer" target="_blank" href="/school/contracts">

                                        <i class="fa fa-credit-card text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> قراردادها </span>

                                    </a>

                                </li>

                                <!-- گزارش مالی -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_School_Financial_Report">

                                    <a class="w-100 pointer" target="_blank" href="/school/financial-Report">

                                        <i class="fa fa-credit-card text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> گزارش مالی </span>

                                    </a>

                                </li>

                                <!-- گزارش چک ها -->

                                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bSchool_School_Financial_Report">

                                    <a class="w-100 pointer" target="_blank" href="/school/checks-Report">

                                        <i class="fa fa-credit-card text-dark ms-2"></i>

                                        <span class="text-dark ms-2 f14 bold"> گزارش چک ها </span>

                                    </a>

                                </li>

                            </ul>

                        </li>

                    </ul>

                </li>

            </ul>

        </li>

        <!-- راهنما و ارتباط با ما -->
        <li class="nav-item" *ngIf="helpContactAccessibility">

            <a class="nav-link pointer hoverMenu">راهنما و ارتباط با ما<b class="float-end">&raquo;</b> </a>

            <ul class="submenu dropdown-menu">

                <!-- درباره برنامه -->
                <li class="pointer p-1 hoverMenu" (click)="getLink(3)" *ngIf="acssess.bAbout">
                    <i class="fa fa-exclamation-circle text-dark ms-2"></i>
                    <span class="text-dark ms-2 f14 bold">درباره برنامه</span>
                </li>

                <!-- ارتباط با شرکت -->
                <li class="pointer p-1 hoverMenu" (click)="company()" *ngIf="acssess.bAboutCompany">
                    <i class="fa fa-building-o text-dark ms-2"></i>
                    <span class="text-dark ms-2 f14 bold">ارتباط با شرکت</span>
                </li>

                <!-- راهنما -->
                <li class="pointer p-1 hoverMenu" data-bs-toggle="modal" data-bs-target="#help-Modal">
                    <i class="fa fa-question-circle text-dark ms-2" aria-hidden="true"
                        title="راهنمای چند رسانه ای سامانه"></i>
                    <span class="text-dark ms-2 f14 bold">راهنما</span>
                </li>

                <!-- فروشگاه -->
                <li class="pointer p-1 hoverMenu" *ngIf="accessibility('bShop')" (click)="getLink(0)">

                    <i class="fa fa-shopping-cart text-dark ms-2" aria-hidden="true"></i>

                    <span class="text-dark ms-2 f14 bold">فروشگاه</span>

                </li>

                <!--  اخبار  -->
                <li class="pointer p-1 hoverMenu">

                    <a class="w-100 pointer" target="_blank" routerLink="/news">

                        <i class="fa fa-newspaper-o text-dark ms-2" aria-hidden="true"></i>

                        <span class="text-dark ms-2 f14 bold"> اخبار </span>

                    </a>

                </li>

                <!-- آموزشگاه -->
                <li class="pointer p-1 hoverMenu">
                    <a class="w-100 pointer" target="_blank" routerLink="/educations">
                        <i class="fa fa-file-video-o text-dark ms-2" aria-hidden="true"></i>
                        <span class="text-dark ms-2 f14 bold">آموزشگاه</span>
                    </a>
                </li>

                <!-- مدیریت تبلیغات -->
                <li class="pointer p-1 hoverMenu" *ngIf="acssess.bAdvertise_Manage">
                    <a class="w-100 pointer" target="_blank" routerLink="/advertising">
                        <i class="fa fa-play-circle text-dark ms-2" aria-hidden="true"></i>
                        <span class="text-dark ms-2 f14 bold">مدیریت تبلیغات</span>
                    </a>
                </li>

            </ul>

        </li>

    </ul>

</nav>

<!-- رزرو تاکسی شهر, تاکسی بین شهر -->

<ng-container *ngIf="isTrip_Save">

    <taxi-manage [isOpenModal]="true" [isCity]="isInCity" (onClose)="isTrip_Save = false; isInCity=false">

    </taxi-manage>

</ng-container>